import { useSortable } from "@dnd-kit/sortable";
import type { Choice } from "@memorang/types/src/session/new-session";
import { View } from "react-native";

type Props = {
	id: string;
	index: number;
	item: Choice;
	renderItem: (
		item: Choice,
		index: number,
		drag: () => void,
	) => React.ReactNode;
};

export const SortableItem = ({ id, index, renderItem, item }: Props) => {
	const { attributes, listeners, setNodeRef, transform, transition } =
		useSortable({ id });

	const style = {
		transform: transform
			? [
					{ translateX: transform.x || 0 },
					{ translateY: transform.y || 0 },
					{ scaleX: transform.scaleX || 1 },
					{ scaleY: transform.scaleY || 1 },
				]
			: [],
		transition,
	};

	return (
		// @ts-expect-error
		<View ref={setNodeRef} style={style} {...attributes} {...listeners}>
			{renderItem(item, index, () => {})}
		</View>
	);
};
